import React from "react";
import { useLocation } from "react-router-dom";
import TestTakerMainScreen28 from "./testTakerMainScreen28";

const MainTest28Screen = () => {
    const location = useLocation();
    const testData = location.state.test28Data;
    const isWarmUp = location.state.warmUp;
    const sessionId = JSON.parse(
        sessionStorage.getItem("session_data")
    ).sessionId;
    const testId = JSON.parse(sessionStorage.getItem("test")).id;

    return (
        <>
            <TestTakerMainScreen28
                isWarmUp={isWarmUp}
                testData={testData}
                testId={testId}
                sessionId={sessionId}
            />
        </>
    );
};

export default MainTest28Screen;
